<template>
    <section class="mx-auto max-w-7xl px-6 lg:px-8 pt-16 sm:pt-40">
        <div class="w-full flex-col justify-start items-start inline-flex">
            <div class="w-full flex-col justify-start items-center gap-3.5 flex lg:pb-12 pb-10">
                <h2 class="text-center text-white text-4xl font-bold font-manrope leading-normal">{{ t('pages.faceSwapPhoto.explore.title') }}</h2>
                <p class="lg:max-w-4xl w-full text-center text-white/50 text-base font-normal leading-relaxed">
                    {{ t('pages.faceSwapPhoto.explore.subtitle') }}</p>
            </div>
            <div class="w-full justify-start items-start gap-5 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                <div class="w-full justify-start items-start gap-5 flex flex-col">
                    <div
                        class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out justify-start items-start gap-3 inline-flex">
                        <div class="pt-1 justify-start items-center gap-2.5 flex">
                            <div class="w-[22px] h-[22px] relative">
                                <img src="/idx/ic_photo_explore_01.svg" alt="Icon" class="w-6 h-6">

                            </div>
                        </div>
                        <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                            <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapPhoto.explore.genderSwap.title') }}
                            </h3>
                            <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapPhoto.explore.genderSwap.description') }}</p>
                        </div>
                    </div>
                    <div
                        class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-5 flex">
                        <div class="justify-start items-start gap-3 inline-flex">
                            <div class="pt-1 justify-start items-center gap-2.5 flex">
                                <div class="w-[22px] h-[22px] justify-center items-center flex">
                                    <img src="/idx/ic_photo_explore_02.svg" alt="Icon" class="w-6 h-6">

                                </div>
                            </div>
                            <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapPhoto.explore.paintings.title') }}</h3>
                                <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapPhoto.explore.paintings.description') }}</p>
                            </div>
                        </div>
                        <img class="w-full aspect-[3/2] rounded-lg object-cover" src="/idx/png_photo_explore_01.jpg"
                            alt="Features Medical Website image" />
                    </div>
                </div>
                <div class="w-full justify-start items-start gap-5 flex flex-col">
                    <div
                        class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-5 flex">
                        <div class="justify-start items-start gap-3 inline-flex">
                            <div class="pt-1 justify-start items-center gap-2.5 flex">
                                <div class="w-[22px] h-[22px] relative">
                                    <img src="/idx/ic_video_explore_03.svg" alt="Icon" class="w-6 h-6">
                                </div>
                            </div>
                            <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapPhoto.explore.headshot.title') }}</h3>
                                <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapPhoto.explore.headshot.description') }}</p>
                            </div>
                        </div>
                        <img class="w-full aspect-[3/2] rounded-lg object-cover" src="/idx/png_photo_explore_02.jpg"
                            alt="Features Medical Website image" />
                    </div>
                    <div
                        class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out justify-start items-start gap-3 inline-flex">
                        <div class="pt-1 justify-start items-center gap-2.5 flex">
                            <div class="w-[22px] h-[22px] relative">
                                <img src="/idx/ic_video_explore_04.svg" alt="Icon" class="w-6 h-6">

                            </div>
                        </div>
                        <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                            <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapPhoto.explore.memes.title') }}
                            </h3>
                            <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapPhoto.explore.memes.description') }}</p>
                        </div>
                    </div>
                </div>
                <div class="w-full justify-start items-start gap-5 flex flex-col">
                    <div
                        class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out justify-start items-start gap-2.5 inline-flex">
                        <div class="pt-1 justify-start items-center gap-2.5 flex">
                            <div class="w-[22px] h-[22px] relative">
                                <img src="/idx/ic_video_explore_05.svg" alt="Icon" class="w-6 h-6">

                            </div>
                        </div>
                        <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                            <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapPhoto.explore.friendFamily.title') }}</h3>
                            <p class="text-white/50 text-sm font-normal leading-snug break-all">{{ t('pages.faceSwapPhoto.explore.friendFamily.description') }}</p>
                        </div>
                    </div>
                    <div
                        class="w-full p-5 bg-white/5 hover:bg-white/10 rounded-2xl ring-1 ring-white/10 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-5 flex">
                        <div class="justify-start items-start gap-3 inline-flex">
                            <div class="pt-1 justify-start items-center gap-2.5 flex">
                                <div class="w-[22px] h-[22px] relative">
                                    <img src="/idx/ic_video_explore_06.svg" alt="Icon" class="w-6 h-6">
                                </div>
                            </div>
                            <div class="flex-col justify-start items-start gap-1.5 inline-flex">
                                <h3 class="text-white text-lg font-medium leading-relaxed">{{ t('pages.faceSwapPhoto.explore.socialMedia.title') }}</h3>
                                <p class="text-white/50 text-sm font-normal leading-snug">{{ t('pages.faceSwapPhoto.explore.socialMedia.description') }}</p>
                            </div>
                        </div>
                        <img class="w-full aspect-[3/2] rounded-lg object-cover" src="/idx/png_photo_explore_03.jpg"
                            alt="Features Medical Website image" />
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-12 w-full flex justify-center">
            <FaceSwapBtn></FaceSwapBtn>
        </div>
    </section>
</template>
<script setup lang="ts">
import FaceSwapBtn from './FaceSwapBtn.vue';

const { t } = useI18n();
</script>